import React, { Fragment, useEffect, useState } from "react";
import * as constants from "../../../utils/Constants";

const AgentDashboard = () => {
    const [statistics, setStatistics] = useState([])
    const loggedInUser = JSON.parse(localStorage.getItem('user'))

    useEffect(() => {
        window.scrollTo(0, 0)
        fetch(`${constants.AgentDashboardDataUrl}/${loggedInUser.userId}`, {
            headers: {
                'Authorization': `Bearer ${loggedInUser.sessionToken}`,
            }
        })
            .then(response => response.json())
            .then(res => {
                setStatistics(res.data)
            })
    }, [])

    return (
        <Fragment>
            <div className="row">
                <div className="col-xl-2 col-xxl-4 col-md-4 col-sm-6">
                    <div className="card">
                        <div className="card-body">
                            <div className="row d-flex justify-content-between">
                                <p className="text-black mb-0">Top Recruiting Agents</p>
                            </div>
                            <span className="fs-28 text-black font-w600 mb-5 d-block">
                                5
                            </span>
                            <div className="d-flex align-items-center">
                                <span className="min-w42 mr-3">
                                    <i aria-hidden="true" style={{ fontSize: 30, color: '#E6273E' }} className="fa fa-user"></i>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-xl-2 col-xxl-4 col-md-4 col-sm-6">
                    <div className="card">
                        <div className="card-body">
                            <div className="row d-flex justify-content-between">
                                <p className="text-black mb-0">Jobs Posted</p>
                            </div>
                            <span className="fs-28 text-black font-w600 mb-5 d-block">
                                {statistics?.numberOfJobPosted}
                            </span>
                            <div className="d-flex align-items-center">
                                <svg
                                    className="min-w42 mr-3"
                                    width={42}
                                    height={42}
                                    viewBox="0 0 42 42"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <g clipPath="url(#clip0)">
                                        <path
                                            d="M38.4998 10.4995H35.0002V38.4998H38.4998C40.4245 38.4998 42 36.9238 42 34.9991V13.9991C42 12.075 40.4245 10.4995 38.4998 10.4995Z"
                                            fill="#3F9AE0"
                                        />
                                        <path
                                            d="M27.9998 10.4995V6.9998C27.9998 5.07515 26.4243 3.49963 24.5001 3.49963H17.4998C15.5756 3.49963 14.0001 5.07515 14.0001 6.9998V10.4995H10.5V38.4998H31.5V10.4995H27.9998ZM24.5001 10.4995H17.4998V6.99929H24.5001V10.4995Z"
                                            fill="#3F9AE0"
                                        />
                                        <path
                                            d="M3.50017 10.4995C1.57551 10.4995 0 12.075 0 13.9996V34.9996C0 36.9243 1.57551 38.5003 3.50017 38.5003H6.99983V10.4995H3.50017Z"
                                            fill="#3F9AE0"
                                        />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0">
                                            <rect width={42} height={42} fill="white" />
                                        </clipPath>
                                    </defs>
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-xl-2 col-xxl-4 col-md-4 col-sm-6">
                    <div className="card">
                        <div className="card-body">
                            <div className="row d-flex justify-content-between">
                                <p className="text-black mb-0">Active Jobs</p>
                            </div>
                            <span className="fs-28 text-black font-w600 mb-5 d-block">
                                {statistics?.numberOfActiveJobs}
                            </span>
                            <div className="d-flex align-items-center">
                                <svg
                                    className="min-w42 mr-3"
                                    width={42}
                                    height={42}
                                    viewBox="0 0 42 42"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M33.25 8.74997H31.5V5.24997C31.5 4.78584 31.3156 4.34072 30.9874 4.01253C30.6593 3.68434 30.2141 3.49997 29.75 3.49997C29.2859 3.49997 28.8407 3.68434 28.5126 4.01253C28.1844 4.34072 28 4.78584 28 5.24997V8.74997H14V5.24997C14 4.78584 13.8156 4.34072 13.4874 4.01253C13.1592 3.68434 12.7141 3.49997 12.25 3.49997C11.7859 3.49997 11.3408 3.68434 11.0126 4.01253C10.6844 4.34072 10.5 4.78584 10.5 5.24997V8.74997H8.75C7.35761 8.74997 6.02226 9.30309 5.03769 10.2877C4.05312 11.2722 3.5 12.6076 3.5 14V15.75H38.5V14C38.5 12.6076 37.9469 11.2722 36.9623 10.2877C35.9777 9.30309 34.6424 8.74997 33.25 8.74997Z"
                                        fill="#2BC155"
                                    />
                                    <path
                                        d="M3.5 33.25C3.5 34.6424 4.05312 35.9777 5.03769 36.9623C6.02226 37.9469 7.35761 38.5 8.75 38.5H33.25C34.6424 38.5 35.9777 37.9469 36.9623 36.9623C37.9469 35.9777 38.5 34.6424 38.5 33.25V19.25H3.5V33.25Z"
                                        fill="#2BC155"
                                    />
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-xl-2 col-xxl-4 col-md-4 col-sm-6">
                    <div className="card">
                        <div className="card-body">
                            <div className="row d-flex justify-content-between">
                                <p className="text-black mb-0">Candidates Applied</p>
                            </div>
                            <span className="fs-28 text-black font-w600 mb-5 d-block">
                                {statistics?.numberOfCandidates}
                            </span>
                            <div className="d-flex align-items-center">
                                <span className="min-w42 mr-3">
                                    <i aria-hidden="true" style={{ fontSize: 30, color: '#2BC155' }} className='fa fa-user-plus'></i>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-xl-2 col-xxl-4 col-md-4 col-sm-6">
                    <div className="card">
                        <div className="card-body">
                            <div className="row d-flex justify-content-between">
                                <p className="text-black mb-0">Interview Scheduled</p>
                            </div>
                            <span className="fs-28 text-black font-w600 mb-5 d-block">
                                {statistics?.numberOfCandidatesInterviewScheduled}
                            </span>
                            <div className="d-flex align-items-center">
                                <svg
                                    className="min-w42 mr-3"
                                    width={42}
                                    height={42}
                                    viewBox="0 0 42 42"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <g clipPath="url(#clip1)">
                                        <path
                                            d="M39.5172 32.7361L39.3003 32.2672C38.6496 30.7299 30.6354 28.3739 29.9713 28.3362L29.4399 28.377C28.3472 28.6021 27.1435 29.6376 24.6167 31.8772C21.7702 30.5598 17.8713 27.0487 16.0334 24.9748C14.0432 22.7326 11.5603 18.9618 10.6679 16.1447C13.55 13.5905 14.7507 12.4818 14.8271 11.2486C14.8679 10.5845 13.4932 2.35035 12.0452 1.51531L11.6114 1.24157C10.6896 0.647742 9.29636 -0.249819 7.74812 0.0651832C7.37423 0.143722 7.00806 0.290294 6.66628 0.501594C5.62783 1.15795 3.08493 2.92257 1.92456 5.22985C1.20882 6.6665 0.883478 19.7776 10.7113 30.8608C18.9979 40.2111 28.9285 41.9267 32.7793 42H33.2868C33.6898 41.9914 33.9999 41.9632 34.1903 41.9241L34.2419 41.9159L34.402 41.8668C36.8312 40.9967 38.889 38.6812 39.6616 37.7268C41.0896 35.9596 40.0702 33.8609 39.5172 32.7361Z"
                                            fill="#8743DF"
                                        />
                                    </g>
                                    <defs>
                                        <clipPath id="clip2">
                                            <rect width={42} height={42} fill="white" />
                                        </clipPath>
                                    </defs>
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-xl-2 col-xxl-4 col-md-4 col-sm-6">
                    <div className="card">
                        <div className="card-body">
                            <div className="row d-flex justify-content-between">
                                <p className="text-black mb-0">Offer Released</p>
                            </div>
                            <span className="fs-28 text-black font-w600 mb-5 d-block">
                                {statistics?.numberOfCandidatesOfferReleased}
                            </span>
                            <div className="d-flex align-items-center">
                                <span className="min-w42 mr-3">
                                    <i aria-hidden="true" style={{ fontSize: 30, color: '#2BC155' }} className='fa fa-street-view'></i>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-xl-2 col-xxl-4 col-md-4 col-sm-6">
                    <div className="card">
                        <div className="card-body">
                            <div className="row d-flex justify-content-between">
                                <p className="text-black mb-0">Candidates Joined</p>
                            </div>
                            <span className="fs-28 text-black font-w600 mb-5 d-block">
                                {statistics?.numberOfCandidatesJoined}
                            </span>
                            <div className="d-flex align-items-center">
                                <svg
                                    width={42}
                                    height={42}
                                    viewBox="0 0 42 42"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M15.1812 22.0083C15.0651 21.9063 14.7969 21.6695 14.7015 21.5799C12.3755 19.3941 10.8517 15.9712 10.8517 12.1138C10.8517 5.37813 15.4869 0.0410156 21.0011 0.0410156C26.5152 0.0410156 31.1503 5.37813 31.1503 12.1138C31.1503 15.9679 29.6292 19.3884 27.3094 21.5778C27.2118 21.6699 26.9385 21.9116 26.8238 22.0125L26.8139 22.1799C26.8789 23.1847 27.5541 24.0553 28.5233 24.3626C35.7277 26.641 40.9507 32.0853 41.8277 38.538C41.9484 39.3988 41.6902 40.2696 41.1198 40.9254C40.5495 41.5813 39.723 41.9579 38.8541 41.9579C32.4956 41.9591 9.50675 41.9591 3.14821 41.9591C2.27873 41.9591 1.45183 41.5824 0.881272 40.9263C0.310711 40.2701 0.0524068 39.3989 0.172348 38.5437C1.05148 32.0851 6.27447 26.641 13.4778 24.3628C14.4504 24.0544 15.1263 23.1802 15.1885 22.1722L15.1812 22.0083Z"
                                        fill="#2BC155"
                                    />
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-xl-2 col-xxl-4 col-md-4 col-sm-6">
                    <div className="card">
                        <div className="card-body">
                            <div className="row d-flex justify-content-between">
                                <p className="text-black mb-0">Candidates Rejected</p>
                            </div>
                            <span className="fs-28 text-black font-w600 mb-5 d-block">
                                {statistics?.numberOfCandidatesRejected}
                            </span>
                            <div className="d-flex align-items-center">
                                <svg
                                    width={42}
                                    height={42}
                                    viewBox="0 0 42 42"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M15.1812 22.0083C15.0651 21.9063 14.7969 21.6695 14.7015 21.5799C12.3755 19.3941 10.8517 15.9712 10.8517 12.1138C10.8517 5.37813 15.4869 0.0410156 21.0011 0.0410156C26.5152 0.0410156 31.1503 5.37813 31.1503 12.1138C31.1503 15.9679 29.6292 19.3884 27.3094 21.5778C27.2118 21.6699 26.9385 21.9116 26.8238 22.0125L26.8139 22.1799C26.8789 23.1847 27.5541 24.0553 28.5233 24.3626C35.7277 26.641 40.9507 32.0853 41.8277 38.538C41.9484 39.3988 41.6902 40.2696 41.1198 40.9254C40.5495 41.5813 39.723 41.9579 38.8541 41.9579C32.4956 41.9591 9.50675 41.9591 3.14821 41.9591C2.27873 41.9591 1.45183 41.5824 0.881272 40.9263C0.310711 40.2701 0.0524068 39.3989 0.172348 38.5437C1.05148 32.0851 6.27447 26.641 13.4778 24.3628C14.4504 24.0544 15.1263 23.1802 15.1885 22.1722L15.1812 22.0083Z"
                                        fill="#E6273E"
                                    />
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default AgentDashboard